import { render, staticRenderFns } from "./ImageParagraph.vue.js?vue&type=template&id=09f5a4d3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ImageParagraph.vue?vue&type=template&id=09f5a4d3"
import script from "./ImageParagraph.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ImageParagraph.vue?vue&type=script&lang=js"
export * from "./ImageParagraph.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ImageParagraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports